
let base_url_ = 'https://w4nls80989.execute-api.us-east-1.amazonaws.com/index.php/api/frontend'; // produccion
let onboarding_ = 'https://wn5ijpn406.execute-api.us-west-1.amazonaws.com/index.php/api/ob';

export const base_url = base_url_;
export const onboarding = onboarding_;